<script>
export default {
	name: 'TDestinationLine',
	functional: true,
	props: {
		type: {
			type: String,
			default: 'straight',
			validator(prop) {
				return prop === 'straight' || prop === 'dotted-long' || prop === 'dotted';
			}
		},
		color: {
			type: String,
			default: '#c7ced4'
		},
		width: {
			type: String,
			default: '2px'
		},
		height: {
			type: String,
			default: '29px'
		}
	},
	render(_, context) {
		if (context.props.type === 'straight') {
			return (
				<svg width={context.props.width} height={context.props.height} viewBox="0 0 1 29" version="1.1" xmlns="http://www.w3.org/2000/svg" {...context.data}>
					<g stroke="none" stroke-width={parseInt(context.props.width)} fill="none" fill-rule="evenodd">
						<rect x={-parseInt(context.props.width)/2} width={context.props.width} height={context.props.height} fill={context.props.color}></rect>
					</g>
				</svg>
			);
		} else if (context.props.type === 'dotted') {
			return (
				<svg width={context.props.width} height={context.props.height} viewBox="0 0 1 23" version="1.1" xmlns="http://www.w3.org/2000/svg" {...context.data}>
					<g stroke="none" stroke-width={parseInt(context.props.width)} fill="none" fill-rule="evenodd">
						<g transform="translate(-87.000000, -34.000000)" fill={context.props.color}>
							<path d="M87,34 L88,34 L88,36 L87,36 L87,34 Z M87,37 L88,37 L88,39 L87,39 L87,37 Z M87,40 L88,40 L88,42 L87,42 L87,40 Z M87,43 L88,43 L88,45 L87,45 L87,43 Z M87,46 L88,46 L88,48 L87,48 L87,46 Z M87,49 L88,49 L88,51 L87,51 L87,49 Z M87,52 L88,52 L88,54 L87,54 L87,52 Z M87,55 L88,55 L88,57 L87,57 L87,55 Z"></path>
						</g>
					</g>
				</svg>
			);
		} else if (context.props.type === 'dotted-long') {
			return (
				<svg width={context.props.width} height={context.props.height} viewBox="0 0 1 29" version="1.1" xmlns="http://www.w3.org/2000/svg" {...context.data}>
					<g stroke="none" stroke-width={parseInt(context.props.width)} fill="none" fill-rule="evenodd">
						<g transform="translate(-81.000000, -34.000000)" fill={context.props.color}>
							<path d="M81,34 L82,34 L82,39 L81,39 L81,34 Z M81,42 L82,42 L82,47 L81,47 L81,42 Z M81,50 L82,50 L82,55 L81,55 L81,50 Z M81,58 L82,58 L82,63 L81,63 L81,58 Z"></path>
						</g>
					</g>
				</svg>
			);
		} else return null;
	}
};
</script>
